import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { ForgeCDNEnvironment, type ProductEnvironment } from '@atlassian/forge-ui-types';

import { getCDNEnvironment } from './getCDNEnvironment';

/**
 * Returns the Forge CDN base domain for the given CDN environment.
 *
 * The returned value is the host suffix shared by all Forge CDN assets,
 * i.e. everything after the installation/app-specific subdomain:
 *
 *   cdn.<env>.atlassian-dev.net          (commercial)
 *   cdn.<env>.atlassian-dev-us-gov-mod.net  (FedRamp)
 *
 * The DEVELOPMENT environment is mapped to STAGING because a standalone
 * dev CDN does not exist.
 *
 * Example — building a full domain:
 *   `${installationSlug}--${appSlug}.${getForgeCDNBaseDomain(cdnEnv)}`
 */
export function getForgeCDNBaseDomain(environment: ProductEnvironment): string {
	const cdnEnv = getCDNEnvironment(environment);
	// DEVELOPMENT has no dedicated CDN; fall back to STAGING assets.
	const urlEnv = cdnEnv === ForgeCDNEnvironment.DEVELOPMENT ? ForgeCDNEnvironment.STAGING : cdnEnv;

	const secondLevelDomain = isFedRamp() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';

	return `cdn.${urlEnv}.${secondLevelDomain}.net`;
}
